export default class Locale_LogSettings {
	SeverityLevel: string = "Log level";
	EnablePluginLogging: string = "Enable plugin performance logging";
	ExcludeCategoryNames: string = "Exclude category names";
	ExcludeCategoryColumnTitle: string = "Category name";
}